import * as React from "react";

import { getKeywordsAutocomplete } from "headerServices/header/header";
//
import {
	CategoryContainer,
	CategoryBox,
	CategoryContent,
	CategoryItem,
	CategoryListContainer,
	CategoryListName,
	CategoryListContent,
	CategoryListImage,
	SearchContent,
	SearchIcon,
	SelectModal,
	SelectItem,
} from "./styles";
import { SEARCH_RESULT } from "../../utils";
import { WEB_HOST } from "../../../../../utils/constant";


interface CategorySearchProps {
	categories: any[];
}
class CategorySearch extends React.Component<CategorySearchProps> {
	state = {
		isShowIndex: -1,
		categoryData: [],
		keyword: "",
		keywordData: [],
	};
	setCategoryStatus = (index) => {
		const result = [];
		if (index !== -1 && this.props.categories[index].node_list.length > 0) {
			const data = this.props.categories[index].node_list;
			for (let i = 0, len = data.length; i < len; i += 8) {
				result.push(data.slice(i, i + 8));
			}
		}
		this.setState({
			isShowIndex: index,
			categoryData: result,
		});
	};

	searchKeyChange = (e) => {
		const value = e.target.value;
		this.setState(
			{
				keyword: value,
			},
			() => {
				if (value) {
					getKeywordsAutocomplete({
						method: "vela.keywords.autocomplete.get",
						word: value,
						num: 10,
					})
						.then((res: any) => {
							this.setState({
								keywordData: res?.info?.keywords,
							});
						})
						.catch((e) => console.log(e));
				} else {
					this.setState({
						keyword: "",
					});
				}
			},
		);
	};
	searchClick = (val) => {
		this.setState({ keywordData: [] });
		location.href = `${SEARCH_RESULT()}${val}`;
	};
	render(): React.ReactNode {
		const { categories } = this.props;
		const BaseGHost = WEB_HOST["Online"].ghost;
		return (
			<CategoryContainer>
				<CategoryBox onMouseLeave={() => this.setCategoryStatus(-1)}>
					<CategoryContent>
						{categories?.map((item, index) => {
							return (
								<CategoryItem
									onMouseEnter={() => this.setCategoryStatus(index)}
									key={`c_${index}`}
									isActive={this.state.isShowIndex === index}>
									<a href={`${BaseGHost}/c/${item.category_url}_${item.category_id}?prm=1.2.c${item.category_id}.0`}>{item.category_name}</a>
								</CategoryItem>
							);
						})}
					</CategoryContent>
					<CategoryListContainer>
						<CategoryListContent>
							{this.state.categoryData?.map((c, cindex) => {
								return (
									<CategoryListName key={`c_${cindex}`}>
										{c &&
											c?.map((item, i) => {
												return (
													<a href={`${BaseGHost}/c/${item.category_url}_${item.category_id}?prm=1.2.c${item.category_id}.0`} key={`a_${i}`}>
														{item.category_name}
													</a>
												);
											})}
									</CategoryListName>
								);
							})}

							<CategoryListImage>
								{/* 图片不存在占位 */}
								<img
									src={
										(categories &&
											categories[this.state.isShowIndex]
												?.left_image_url) ||
										"https://t.rightinthebox.com/tights/litb/y67ncix2b4w0_ador_banner_456.png"
									}
									alt=""
								/>
							</CategoryListImage>
						</CategoryListContent>
					</CategoryListContainer>
				</CategoryBox>
				<SearchContent>
					<input
						type="text"
						placeholder=""
						onChange={this.searchKeyChange}
					/>
					<SearchIcon onClick={() => this.searchClick(this.state.keyword)}>
						<img src={require("assets/images/ic_search.png")} alt="" />
					</SearchIcon>
					{this.state.keyword && this.state.keywordData.length > 0 && (
						<SelectModal>
							{this.state.keywordData.map((k, i) => {
								return (
									<SelectItem
										key={`k_${i}`}
										onClick={() => this.searchClick(k.keyword)}>
										{k.keyword}
									</SelectItem>
								);
							})}
						</SelectModal>
					)}
				</SearchContent>
			</CategoryContainer>
		);
	}
}

export default CategorySearch;
